import Big from 'bignumber.js';

import { BigToBigInt } from '#src/bigint.ts';

export enum RoundingMode {
  /**
   * Rounds away from zero.
   */
  ROUND_UP = 0,
  /**
   * Rounds towards zero.
   * I.e. truncate, no rounding.
   */
  ROUND_DOWN = 1,
  /**
   * Rounds towards nearest neighbour.
   * If equidistant, rounds away from zero.
   */
  ROUND_HALF_UP = 4,
  /**
   * Rounds towards nearest neighbour.
   * If equidistant, rounds towards even neighbour.
   */
  ROUND_HALF_EVEN = 6,
}

const oneSol = new Big(10).pow(9);

const LAMPORT_DECIMAL_PLACES = 9;

// We enforce only 3 decimals for SOL display
export const SOL_DECIMAL_PLACES = 3;

export const fromLamport = (
  number: string | bigint,
  round = SOL_DECIMAL_PLACES,
  roundingMode = RoundingMode.ROUND_HALF_UP
): number =>
  Number(
    new Big(number.toString()).dividedBy(oneSol).toFixed(round, roundingMode)
  );

export const toLamport = (number: string | number): bigint =>
  BigToBigInt(
    new Big(number).decimalPlaces(LAMPORT_DECIMAL_PLACES).multipliedBy(oneSol)
  );
